var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "modal",
      attrs: { okBtnAction: "send", beforeOkClick: _vm.validateFields },
      on: { onOkClick: _vm.sendReminder, onCloseClick: _vm.cleanModalState },
    },
    [
      _c("template", { slot: "title" }, [
        _c("span", { class: { "required-flag": true } }, [
          _vm._v(
            _vm._s(_vm.$t("tenantProjects.finalDocuments.sendReminder.hint"))
          ),
        ]),
        _vm._v(" "),
        _c("label", [_vm._v(_vm._s(_vm.$t("hint.continue")))]),
      ]),
      _vm._v(" "),
      _c("TextField", {
        staticClass: "check-valid",
        attrs: {
          value: _vm.sendReminderComment,
          required: true,
          placeholder: _vm.$t(
            "tenantProjects.finalDocuments.sendReminder.placeHolder"
          ),
        },
        on: {
          updateValue: function (val) {
            return (_vm.sendReminderComment = val)
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }